// extracted by mini-css-extract-plugin
export var fullGrid = "_2x-3";
export var pdpPreviewContainer = "_2x-1";
export var previewContainer = "_2x-0";
export var togglePreviewContainer = "_2x-2";